import logoMark from '@/assets/become-a-doer-logo.png'
import { cn } from '@/lib/cn'

export function Logo({ className }: { className?: string }) {
  return (
    <img
      src={logoMark}
      alt="Become A Doer"
      className={cn('h-11 w-auto object-contain', className)}
    />
  )
}
